/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */


expocadfx.setupFloorPlanToolbar = function() {
	'use strict';
    var data = expocadfx.fxData;
    var fxStyle = expocadfx.styles;
    var txt = expocadfx.txt;
    var elem = expocadfx.element;
	var elemById = elem.elementById;
	var config = expocadfx.config;
	var bgColorNone = 'none';
	
	
	var bgColor = fxStyle.fpToolbar.clrBg !== "" ?
				fxStyle.fpToolbar.clrBg : fxStyle.floorplan.clrBg !== "" ?
				fxStyle.floorplan.clrBg : fxStyle.mainHeader.clrBg;

	var txtColor = fxStyle.fpToolbar.clrText !== "" ?
				fxStyle.fpToolbar.clrText : fxStyle.floorplan.clrText !== "" ?
				fxStyle.floorplan.clrText : fxStyle.mainHeader.clrText;
	//changing Sales Menu to toolbar color
	elemById( "control1").appendChild( 
			elem.makeIconButton( "tb4", txt.CLEAR_ALL, bgColor, txtColor, elem.ICON_PIN, 
										false, fxStyle.fpToolbar.alpha));
	if(config.salesMode === "none" && config.elvis === false && config.is3d === true && !data.smallLayout){				
		elemById("control1").appendChild(
			elem.makeIconButton("show3d", txt.SHOW_3D, bgColorNone, txtColor, elem.ICON_NONE,
											false, fxStyle.fpToolbar.alpha));
		if(config.openIn3D){
			document.getElementById("show3dLabel").classList.add("icon-check");
			var ThreeDEl = elemById('show3d');
			ThreeDEl.style.color = bgColor
			}
		}
	elemById( "control1").appendChild( 
			elem.makeIconButton( "tb5", txt.FIT, bgColor, txtColor, elem.ICON_FIT, 
								true, fxStyle.fpToolbar.alpha));
		// no plus and minus buttons on phones and tablets
	if( data.device !== "ios" && data.device !== "A" && !data.smallLayout) {
		elemById( "control1").appendChild( 
			elem.makeIconButton( "tb3", "", bgColor, txtColor, elem.ICON_MINUS, 
								true, fxStyle.fpToolbar.alpha));
		elemById( "control1").appendChild( 
			elem.makeIconButton( "tb2", "", bgColor, txtColor, elem.ICON_PLUS, 
								true, fxStyle.fpToolbar.alpha));
	}
	if ( config.locationAvailable && data.device != "other") {
		elemById( "control1").appendChild( 
			elem.makeIconButton( "tb6", "", "#dcdcdc", txtColor, elem.ICON_LOCATION, 
								true, fxStyle.fpToolbar.alpha));
	}
};
